module.exports = __webpack_public_path__ + "static/media/addImage.6016b980.png";